import { SagaObject } from '@models/imported/SagaBase/SagaObject';
import { Actor } from '@models/imported/SagaSchema/Actor';
import { CommunicationEquipment } from '@models/imported/SagaSchema/CommunicationEquipment';
import { ListUnitTypes } from '@models/imported/SagaSchema/ListObjects/ListUnitTypes';
import { Vehicle } from '@models/imported/SagaSchema/Vehicle';
import { ListItem } from './list-item';

export type UnitTabType = Vehicle | Actor | CommunicationEquipment;

export interface ITabState {
  type: string;
  searchText: string;
  offset: number;
  actualList: ListItem<UnitTabType>[];
}

export class UnitEditor {
  readonly vehicles: Vehicle[] = [];
  readonly actors: Actor[] = [];
  readonly communicationEquipments: CommunicationEquipment[] = [];
  readonly tabsStates: ITabState[] = [];

  name: string = '';

  mainResource: SagaObject = null;

  agent: Actor = null;

  positionProvider: SagaObject = null;

  communicationEquipment: CommunicationEquipment = null;

  unitType: ListUnitTypes = null;
}
